import type { IChallengeType } from './enums/challenge-type';

const CHALLENGE_TYPE_LABELS: Record<IChallengeType, string> = {
  word: 'Word',
  phrase: 'Phrase',
  idiom: 'Idiom',
  chunk: 'Chunk',
  // biome-ignore lint/style/useNamingConvention: db enum value
  phrasal_verb: 'Phrasal Verb',
};

export function getChallengeTypeLabel(type: string): string {
  return CHALLENGE_TYPE_LABELS[type as IChallengeType] ?? type;
}
